import React, { useState, useEffect, useRef } from 'react';
import Icon from '../AppIcon';

const NotificationCenter = ({ role = 'influencer' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const dropdownRef = useRef(null);

  const mockNotifications = {
    influencer: [
      {
        id: 1,
        title: 'Purchase Approved',
        description: 'Your $45.99 purchase at Nike Store has been approved',
        time: '2 hours ago',
        icon: 'CheckCircle',
        unread: true
      },
      {
        id: 2,
        title: 'SocialCents Score Updated',
        description: 'Your score increased to 850 - Great job!',
        time: '5 hours ago',
        icon: 'TrendingUp',
        unread: true
      },
      {
        id: 3,
        title: 'New Brand Partnership',
        description: 'Adidas wants to collaborate with you',
        time: '1 day ago',
        icon: 'Handshake',
        unread: false
      }
    ],
    brand: [
      {
        id: 1,
        title: 'Campaign Performance',
        description: 'Your Spring Campaign reached 10K impressions',
        time: '1 hour ago',
        icon: 'BarChart3',
        unread: true
      },
      {
        id: 2,
        title: 'New Influencer Match',
        description: '5 influencers match your campaign criteria',
        time: '3 hours ago',
        icon: 'Users',
        unread: true
      }
    ],
    admin: [
      {
        id: 1,
        title: 'Pending Reviews',
        description: '12 transactions awaiting moderation',
        time: '30 minutes ago',
        icon: 'AlertCircle',
        unread: true
      },
      {
        id: 2,
        title: 'System Alert',
        description: 'Platform maintenance scheduled for tonight',
        time: '2 hours ago',
        icon: 'Settings',
        unread: false
      }
    ]
  };

  useEffect(() => {
    setNotifications(mockNotifications?.[role] || mockNotifications?.influencer);
  }, [role]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const unreadCount = notifications?.filter(n => n?.unread)?.length;

  const handleNotificationClick = (notificationId) => {
    setNotifications(prev =>
      prev?.map(n =>
        n?.id === notificationId ? { ...n, unread: false } : n
      )
    );
  };

  const handleMarkAllRead = () => {
    setNotifications(prev =>
      prev?.map(n => ({ ...n, unread: false }))
    );
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="notification-center-trigger"
        aria-label="Notifications"
      >
        <Icon name="Bell" size={20} />
        {unreadCount > 0 && (
          <span className="notification-badge">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>
      <div className={`notification-center-dropdown scrollbar-custom ${!isOpen ? 'closed' : ''}`}>
        <div className="notification-center-header">
          <h3 className="notification-center-title">Notifications</h3>
          {unreadCount > 0 && (
            <button
              onClick={handleMarkAllRead}
              className="text-xs text-primary hover:text-primary/80 transition-colors"
            >
              Mark all read
            </button>
          )}
        </div>

        {notifications?.length > 0 ? (
          <div className="notification-center-list">
            {notifications?.map((notification) => (
              <div
                key={notification?.id}
                onClick={() => handleNotificationClick(notification?.id)}
                className={`notification-item ${notification?.unread ? 'unread' : ''}`}
              >
                <div className="notification-item-content">
                  <div className="notification-item-icon">
                    <Icon name={notification?.icon} size={16} />
                  </div>
                  <div className="notification-item-text">
                    <div className="notification-item-title">
                      {notification?.title}
                    </div>
                    <div className="notification-item-description">
                      {notification?.description}
                    </div>
                    <div className="notification-item-time">
                      {notification?.time}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="notification-center-empty">
            <Icon name="Bell" size={32} color="var(--color-muted-foreground)" />
            <p className="notification-center-empty-text mt-2">
              No notifications yet
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationCenter;